import React, { useContext, useState } from 'react';
import {
    mergeStyleSets,
    FocusTrapCallout,
    FocusZone,
    FocusZoneTabbableElements,
    FontWeights,
    Stack,
    Checkbox,
    Toggle,
    IconButton,
} from '@fluentui/react';
import { t } from 'i18next';
import MainAppContext from '../../../../../MainAppContext';
import { setBoardCalendarFilterConfig, setBoardFieldDisplay, setLocalStorageValue } from '../../../../../common/Helpers';
import { ActionButton, DefaultButton, PrimaryButton } from '@fluentui/react';
import { useManipulateFilterFields } from '../../../../../hooks/component/useOfTransversal';
import { useDispatch, useSelector } from 'react-redux';
import { action_setAllBoardViewNull } from '../../../../../reducers/actions/KPI/actions';
import SidePanelDataserieClose from './DataserieClose/SidePanelDataserieClose';

export const CalloutFocusTrapExample = (props) => {
const contextSite = useContext(MainAppContext);
const dispatch = useDispatch();
const { _elementId: elementId } = useSelector((state) => state.boardViewScope);
const { _boardVariableDataserieValues: boardVariableDataserieValues } = useSelector((state) => state.boardViewScope);


const inputParam_ShowButton = props.showButton !== null && props.showButton !== undefined ? props.showButton : false;
const inputParam_IsCalloutVisible = props.isCalloutVisible !== null && props.isCalloutVisible !== undefined ? props.isCalloutVisible : null;
const inputParam_ToggleIsCalloutVisible = props.toggleIsCalloutVisible !== null && props.toggleIsCalloutVisible !== undefined ? props.toggleIsCalloutVisible : null;
const inputParam_BoardId = props.inputParam_BoardId !== null && props.inputParam_BoardId !== undefined ? props.inputParam_BoardId : null;
const inputParam_SetGroupDataseriesInOneList = props.inputParam_SetGroupDataseriesInOneList !== null && props.inputParam_SetGroupDataseriesInOneList !== undefined ? props.inputParam_SetGroupDataseriesInOneList : null;
const inputParam_GroupDataseriesInOneList = props.inputParam_GroupDataseriesInOneList !== null && props.inputParam_GroupDataseriesInOneList !== undefined ? props.inputParam_GroupDataseriesInOneList : null;

const inputParam_SetAggregationDataseries = props.inputParam_SetAggregationDataseries !== null && props.inputParam_SetAggregationDataseries !== undefined ? props.inputParam_SetAggregationDataseries : null;
const inputParam_AggregationDataseries = props.inputParam_AggregationDataseries !== null && props.inputParam_AggregationDataseries !== undefined ? props.inputParam_AggregationDataseries : null;



const [keysMenuOptions, setKeysMenuOptions] = useState(null);
const [groupedDataseries, setGroupedDataseries] = useState(inputParam_GroupDataseriesInOneList);
//const [aggregationValue, setAggregationValue] = useState(contextSite.kpiModule.boardCalendarFilterConfig.value.displayAgregationId === 2 ? true : false);
const [aggregationValue, setAggregationValue] = useState(inputParam_AggregationDataseries);
useManipulateFilterFields(keysMenuOptions, setKeysMenuOptions, contextSite.kpiModule.boardDataserieDisplayFields.value,
    contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId,
    contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate,
    contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate);

const onChange = (ev, checked) => {
    let index = parseInt(ev.target.attributes["name"].value)

    const newArray = keysMenuOptions.map((item, i) => {
        if (index === i) {
            return { ...item, ["isChecked"]: checked };
        } else {
            return item;
        }
    });

    setKeysMenuOptions(newArray);
}

const onSelectFieldFilter = () => {
    let newValues = keysMenuOptions.filter(x => x.isChecked).map(({ field, simbol }) => ({ field: field, simbol: simbol}));
    let _aggregationValue = aggregationValue === false ? 1 : 2;

    contextSite.kpiModule.boardCalendarFilterConfig.value.displayAgregationId = _aggregationValue
    contextSite.kpiModule.boardCalendarFilterConfig.value.fireFilter = true;
    setBoardFieldDisplay(newValues)
    setBoardCalendarFilterConfig(contextSite.kpiModule.boardCalendarFilterConfig.value)

    contextSite.kpiModule.boardDataserieDisplayFields.setter(newValues)
    contextSite.kpiModule.boardCalendarFilterConfig.setter(prevState => ({
        ...prevState,
        displayAgregationId: _aggregationValue,
        fireFilter: true
    }))

    
    inputParam_SetGroupDataseriesInOneList(groupedDataseries)
    inputParam_SetAggregationDataseries(aggregationValue)
    setLocalStorageValue('PARAM_COOKIE_DATASERIES_GROUPED' + inputParam_BoardId, groupedDataseries)
    setLocalStorageValue('PARAM_COOKIE_DATASERIES_AGGREGATED' + inputParam_BoardId, aggregationValue)

    dispatch(action_setAllBoardViewNull());

    window.location.href = window.location.href;
}

const onAggregationChange = (e, checked) => {
    setAggregationValue(checked)
}

const onGroupDataseries = (e, checked) => {
    setGroupedDataseries(checked)
};

return (
        <>
        {
            inputParam_ShowButton &&
            <ActionButton id={"filter-board-field-callout-button"} iconProps={{ iconName: 'Settings' }} styles={{root: {height: "30px"}}} allowDisabledFocus onClick={inputParam_ToggleIsCalloutVisible}>
                {t('data-lang-lbl-configuration')}
            </ActionButton>
        }
        {inputParam_IsCalloutVisible ? (
            <FocusTrapCallout
                role="alertdialog"
                className={styles.callout}
                gapSpace={0}
                target={`#${"filter-board-field-callout-button"}`}
                onDismiss={inputParam_ToggleIsCalloutVisible} 
                focusTrapProps={{
                    isClickableOutsideFocusTrap: true
                }}
            >
                <h6><b>{t('data-lang-lbl-selectfields')}</b></h6>
                <Stack tokens={{ childrenGap: 10 }}>
                    {
                        keysMenuOptions.map((item, index) => (
                            <div key={index}>
                                {
                                    item.field !== "AGGR_TYPE" &&
                                    <Checkbox label={t(item.label)} name={index} disabled={!item.enabled} checked={ item.isChecked } onChange={onChange} />
                                }
                            </div>
                        ))
                    }
                </Stack>
                <br/>
                <Toggle
                    checked={aggregationValue}
                    onChange={ onAggregationChange }
                    role="checkbox"
                    onText={ t('data-lang-lbl-defftimeaggregation') }
                    offText={ t('data-lang-lbl-defftimeaggregation') }
                />
                <Toggle
                    checked={groupedDataseries}
                    onChange={ onGroupDataseries }
                    role="checkbox"
                    onText={ t('data-lang-btn-groupdataseries') }
                    offText={ t('data-lang-btn-groupdataseries') }
                />                
                
                <FocusZone handleTabKey={FocusZoneTabbableElements.all} isCircularNavigation>
                    <Stack className={styles.buttons} horizontal>
                        <PrimaryButton className='me-2' onClick={onSelectFieldFilter}>{t('data-lang-btn-filter')}</PrimaryButton>
                        <DefaultButton onClick={inputParam_ToggleIsCalloutVisible}>{t('data-lang-btn-close')}</DefaultButton>
                    </Stack>
                </FocusZone>
            </FocusTrapCallout>
        ) : null}
        </>
)};

const styles = mergeStyleSets({
    callout: {
        width: 320,
        padding: '20px 24px',
    },
    title: {
        marginBottom: 12,
        fontWeight: FontWeights.semilight,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 20,
        paddingLeft: 10,
    },
});
